export const CRITICAL_EXPIRY_DAYS = 30
export const WARNING_EXPIRY_DAYS = 90
